import { ReactNode } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import { RiExpandDiagonalSLine } from '@remixicon/react';
import classNames from 'classnames';

import {
  ButtonIcon,
  Flex,
  FlexProps,
  Tag,
  TagGroup,
  Text,
} from '@backstage/ui';

const styles = createStyles({
  root: {
    position: 'relative',
    flexDirection: 'column',
    gap: 'var(--bui-space-1)',
  },
  header: {
    alignItems: 'center',
    gap: 'var(--bui-space-2)',
  },
  title: {
    flex: 1,
    minWidth: 0,
    alignItems: 'center',
    gap: 'var(--bui-space-2)',
  },
  expandButton: {
    flexShrink: 0,
    selfAlign: 'start',
    marginRight: '-6px', // Alignment adjustment
  },
  tagGroup: {
    flexShrink: 0,
  },
});

export interface ActivityItemPanelProps
  extends Omit<FlexProps, 'title'>,
    WithStyles<typeof styles> {
  title?: ReactNode;
  tagLabel?: string;
  ariaLabel?: string;
  onExpand?: () => void;
}

const ActivityItemPanel = ({
  classes,
  className,
  children,
  onExpand,
  title,
  tagLabel,
  ariaLabel,
  ...props
}: ActivityItemPanelProps) => {
  return (
    <Flex className={classNames(classes.root, className)} {...props}>
      {(title || tagLabel || onExpand) && (
        <Flex className={classes.header}>
          {(title || tagLabel) && (
            <Flex className={classes.title}>
              {title && (
                <Text variant="body-medium" weight="bold">
                  {title}
                </Text>
              )}
              {tagLabel && (
                <TagGroup aria-label={ariaLabel} className={classes.tagGroup}>
                  <Tag>{tagLabel}</Tag>
                </TagGroup>
              )}
            </Flex>
          )}
          {onExpand && (
            <ButtonIcon
              variant="tertiary"
              size="small"
              icon={<RiExpandDiagonalSLine />}
              onClick={onExpand}
              className={classes.expandButton}
            />
          )}
        </Flex>
      )}
      {children}
    </Flex>
  );
};

export default withStyles(styles)(ActivityItemPanel);
